import type { maxDimensionsType } from "../genetic_optimize/OptimizationParameters";

export interface OptimizationParameters {
  desiredAspectRatio: number;
  maxDimensions: maxDimensionsType;
}

export const DEFAULT_OPTIMIZATION_PARAMETERS: OptimizationParameters = {
  desiredAspectRatio: 1.6,
  maxDimensions: {},
};
